import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";

export default function useCourse(){

    const { id } = useParams()

    const query = useQuery({

        queryKey: ['apply', 'course', id],

        queryFn: async () => {

            if(!id) return null;

            try {
                const response = await API.get(`/courses/${id}`);

                return response.data;

            }catch(e){

                return null;
            }

        }

    })

    return query.isSuccess ? query.data : null
}